import { Input } from "ui";

export interface TextBaseProps {
  id: string;
  onChange(value: string): void;
  value: string;
  disabled?: boolean;
}

export type TextProps = TextBaseProps;

export function Text(props: TextProps) {
  if (props.disabled) {
    return (
      <div
        id={props.id}
        className="min-h-9 w-full whitespace-pre-wrap break-words rounded-md border border-input px-3 py-2 text-sm"
      >
        {props.value}
      </div>
    );
  }

  return (
    <Input
      id={props.id}
      value={props.value}
      onChange={(e) => {
        props.onChange(e.target.value);
      }}
    />
  );
}
